<template>
<div class="card">
   <div class="card-body container-fluid">
     <b-form>
        <div>
            <b-card no-body class="border-0 bg-white">
            <b-tabs pills card vertical content-class="bg-white" nav-class="bg-white mr-1 pr-10">
            <b-tab  active>
                    <template v-slot:title >
                        <b-icon icon="list-check"></b-icon> Challan List
                    </template>
                    <div class="card p-3 m-n2 acc-lists">
                    <div class="row clearfix mt-3 mb-3">
                    <div class="col-md-6 float-left">
                     <div class="border rounded p-2 custom-info">Challans for {{empdata.name}}</div>
                    </div>
                    <div class="col-md-4 offset-md-2 justify-content-right text-right">
                      <b-form-select v-model="fiscals" class="mb-3" v-on:change="filterFiscalYear">
                      <b-form-select-option v-for="(fiscal_year,index)  in fiscal_years" :key="index"  :value="fiscal_year.fiscal_year">{{fiscal_year.fiscal_year}}</b-form-select-option>
                      </b-form-select>
                    </div>
                    </div>
                    <div role="tablist">
                        <b-card no-body class="mb-1" v-for="(challan,index)  in challans" :key="challan.month">
                          <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button block v-b-toggle="'accordion-'+(index+1)" variant="info" @click="challanLoad(challan.month)" class="c-accordion">Challan for {{empdata.name}} (eTIN-{{empdata.etin}}) - {{challan.month}} {{get_year_from_fiscal(challan.month)}} - {{companies[0]}}  <span class="when-opened float-right"><i class="fa fa-chevron-up" aria-hidden="true"></i></span><span class="when-closed float-right"><i class="fa fa-chevron-down" aria-hidden="true"></i></span></b-button>
                          </b-card-header>
                          <b-collapse :id="'accordion-'+(index+1)" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                             <template>
                             
                             <EmployeeChallanDetails :challanname="'Challan for '+empdata.name+' (eTIN-'+empdata.etin+') - '+challan.month+' '+fiscals" :challan_month="challan.month" :challan_fiscal="fiscals" :employee_id="empdata.employee_id" :employee_name="empdata.name"></EmployeeChallanDetails>

                              </template>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                      </div>
                    </div>
             </b-tab>
            </b-tabs>
            </b-card>
        
        </div>
    </b-form>
    </div>
    </div>
</template>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.c-accordion{background: #fff !important;border: none !important;}
.acc-lists .card{background: #fff !important;}
.acc-lists .card .card-header{background: #fff !important;}
.acc-lists .card .btn-info:focus{box-shadow: none !important;color: inherit;}
.acc-lists .btn:hover{background: #ccc !important;}
.acc-lists .card .fa-chevron-down, .acc-lists .card .fa-chevron-up{color: #4169e1;}
.custom-info{background: #f0f0f0;color: #585858;}
</style>

<script>
import EmployeeChallanDetails from './EmployeeChallanDetails.vue';
    export default{
        
        mounted() {
        }, 
        
        computed: {
        },
      
        components: {
          EmployeeChallanDetails
        },
        data(){
            return {  
                
                challans: [],
                empdata: [],
                companies: [],
                accchallans:[],
                fiscal_years: [],
                fiscals: null,
                curr_fiscal: [],
                year:'',
            }
        },
        methods:{            

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            
           getchallans: function(f_year='')
            {

                   axios.get(this.$api_url+'/employeechallanmonths', {
                            params: {
                                fiscal_year: f_year
                            }
                    }).then(function(response){
                    this.challans = response.data.data.challans;
                    this.empdata = response.data.data.employee_info;
                    this.companies = response.data.data.companies;
                    this.fiscal_years = response.data.data.fiscal_years;
                    this.curr_fiscal = response.data.data.fiscal_year;
                    this.fiscals = response.data.data.fiscal_year;
                }.bind(this));
            },
            challanLoad(card_id){
                if(parseInt(card_id)){
                this.$set(this.accchallans,card_id,1);
                }
            },
            filterFiscalYear(f_year){
                this.getchallans(f_year);
            },
            onSubmit:function(e) 
            {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                
                e.preventDefault();
                let currentObj = this;
                


                });
            },
            
            get_year_from_fiscal: function($month)
            {
                var fyear=this.fiscals;
                var fyear_array=fyear.split("-");
                
                if($month=="January" || $month=="February" || $month=="March" || $month=="April" || $month=="May" || $month=="June")
                return fyear_array[0];
                else
                return fyear_array[1];
                
                }
            
                      
        },
        created: function(){
            this.getchallans();
        }
    }
</script>